export default __webpack_public_path__ + "static/media/why2.53749db3.svg";